<template lang="pug">
.detail.scrollable.h-100
  .mx-4.my-2.px-3.pt-3
    .d-flex.align-items-center
      .d-flex.align-items-end
        .d-flex.text-large.mr-4
          | รายการขายเลขที่
          FormattedEntryNo.ml-2(
            :entryNo='sellRecord.entryNo'
            :orderId='sellRecord.id'
          )
        .text-medium.mr-4
          | {{ formattedDate }}
          | เวลา {{ formattedTime }}
        CustomStatusBadge(
          :status='sellRecord.status'
          type='ORDER_STATUS'
        )
      button.btn.btn-secondary.ml-auto(@click="downloadFile")
        | ดูเอกสาร PDF

    //- .text-small {{ sellRecord }}

    .d-flex.align-items-center.pt-4.pb-3
      CustomerCompactDetailHeader(:data='customer')
      div.ml-auto.mr-4
        .d-flex
          .text-large.mr-3
            | {{ deliveryType }}
          CustomStatusBadge(
            :status='sellRecord.shipmentStatus'
            type='SHIPMENT_STATUS'
          )

        .text-small(v-if='deliveryTypeExtra')
          | {{ deliveryTypeExtra }}
        .text-small.mt-3
          | เลขที่ใบสั่งซื้อจากลูกค้า
          | {{ sellRecord.customer_po_no ? sellRecord.customer_po_no : '-' }}

        .text-small.text-danger(v-if="sellRecord.warehouse_id !== null")
          | เปลี่ยนคลังเป็น {{warehouseName}}

  .d-flex.px-4.py-2
    .text-large รายการสินค้า
    LoadingIndicator.ml-2(v-if='isLoading')
  hr.m-0

  template(v-if='sellRecord')
    .px-4.pt-2
      //- div {{ JSON.stringify(sellRecord) }}
      CustomTable(
        :columns='tableColumns'
        :data='tableData'
      )

    .sticky-bottom.bg-white
      hr.m-0
      .d-flex.justify-content-between.mx-3.px-4.py-4
        .d-flex
          div หมายเหตุ:
          template(v-if='sellRecord.remarks || sellRecord.internal_message')
            ol
              li(v-if='sellRecord.remarks')
                | {{ sellRecord.remarks }}
              li(v-if='sellRecord.internal_message')
                | {{ sellRecord.internal_message }}
          template(v-else)
            .ml-4 -
        .d-flex.flex-column.align-items-end
          .text-medium
            span.mr-3 รวมมูลค่าทั้งสิ้น
            span.ml-4
              | {{ total | currency }}
          .text-xlarge
            span.mr-3 รวมค่าคอมมิชชั่นที่ได้รับ
            span.ml-4
              | {{ totalCommission | currency }}

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    sellRecord: {
      default: () => ({}),
    },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.sellRecord.date).format('D MMMM YYYY');
    },
    formattedTime() {
      return this.$moment(this.sellRecord.time).format('HH:mm');
    },
    deliveryStatus() {
      return this.sellRecord.shipmentStatus;
    },
    deliveryType() {
      const { ship_type: shipType } = this.sellRecord;
      return this.$dictionary.deliveryType[shipType];
    },
    deliveryTypeExtra() {
      return this.sellRecord.ship_to;
    },
    warehouseName() {
      const list = this.availableWarehouse.filter((elm) => {
        if (elm.value && this.sellRecord.warehouse.toString() === elm.value.toString()) return true;
        return false;
      });
      if (list.length > 0) return list[0].text;
      return '';
    },
  },
  watch: {
    sellRecord() {
      this.sellRecordUpdated();
      // this.tableData = newVal.products ? newVal.products : [];
    },
  },
  async mounted() {
    if (this.sellRecord) {
      this.sellRecordUpdated();
    }
    const wareHouseRes = await this.$api.order.availableWarehouse();
    if (wareHouseRes.status === 200) {
      this.availableWarehouse = wareHouseRes.data;
    }
  },
  data: () => ({
    availableWarehouse: [],
    tableColumns: {
      productId: {
        title: 'รหัสสินค้า',
        computed(row) {
          return row.product.id;
        },
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
        computed(row) {
          return row.product.name;
        },
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      productPrice: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
        computed(row) {
          return Number(row.price) / Number(row.amount);
        },
      },
      totalPrice: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        computed(row) {
          return row.price;
        },
      },
    },
    tableData: {},
    isLoading: false,

    total: 0,
    totalCommission: 0,
  }),
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    async downloadFile() {
      const url = await this.$api.order.getReportURL(this.sellRecord.id);
      window.open(url);
    },
    // async loadData() {
    //   this.isLoading = true;

    //   const res = await this.$api.history.sellRecordItems(this.sellRecord.entryNo);
    //   if (res.status === 200) {
    //     this.tableData = res.data.data;
    //   }

    //   this.isLoading = false;
    // },
    sellRecordUpdated() {
      this.tableData = this.sellRecord.products ? this.sellRecord.products : [];

      let total = 0;
      let totalCommission = 0;
      for (let i = 0; i < this.sellRecord.products.length; i += 1) {
        const PROD = this.sellRecord.products[i];
        // console.log(PROD);
        total += (Number(PROD.price));
        totalCommission += (Number(PROD.commission));
        console.log(totalCommission);
      }

      this.total = total;
      this.totalCommission = totalCommission;

      // console.log('updated!!');
      // console.log(`${total} ${totalCommission}`);
    },
  },
  components: {
    CustomerCompactDetailHeader,
  },
};
</script>

<style lang="scss">
// .detail {}
</style>
